module.exports = __webpack_public_path__ + "static/works-herren-site-c0b3a370f35951039c9fc48a929dcf16.png";